// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"16823":"935d5e2cc0fc8ff482db","43471":"bd41ec6c5bdebb815bc1","44139":"d7af87f61a81e53c05ae","45002":"52ae922c0a3d3fdc19bf","56430":"fecafe81d914bc6af051","60868":"5f3f4f7ca2ac9f812f9d","69271":"89c5e6ac863b5646a1b1","97228":"63e33a8f49f2beb61342"}[chunkId] + ".min.js";
};